// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_settings.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/admin_settings.proto.
 */
export const file_travplaces_v1_admin_settings: GenFile = /*@__PURE__*/
  fileDesc("CiJ0cmF2cGxhY2VzL3YxL2FkbWluX3NldHRpbmdzLnByb3RvEg10cmF2cGxhY2VzLnYxIjQKEVNldFNldHRpbmdSZXF1ZXN0EgsKA2tleRgBIAEoCRISCgp2YWx1ZV9qc29uGAIgASgJIhQKElNldFNldHRpbmdSZXNwb25zZSInChRSZXN0YXJ0RW5naW5lUmVxdWVzdBIPCgdzZXJ2aWNlGAEgASgJIioKFVJlc3RhcnRFbmdpbmVSZXNwb25zZRIRCglyZXN0YXJ0ZWQYASABKAkiGwoZVGVzdEV4dGVybmFsU2VhcmNoUmVxdWVzdCJQChpUZXN0RXh0ZXJuYWxTZWFyY2hSZXNwb25zZRIRCglhdmFpbGFibGUYASABKAgSDgoGcmVhc29uGAIgASgJEg8KB3Jlc3VsdHMYAyADKAky3gIKFEFkbWluU2V0dGluZ3NTZXJ2aWNlEl4KClNldFNldHRpbmcSIC50cmF2cGxhY2VzLnYxLlNldFNldHRpbmdSZXF1ZXN0GiEudHJhdnBsYWNlcy52MS5TZXRTZXR0aW5nUmVzcG9uc2UiC4rqMAMKARSQ6jACEmcKDVJlc3RhcnRFbmdpbmUSIy50cmF2cGxhY2VzLnYxLlJlc3RhcnRFbmdpbmVSZXF1ZXN0GiQudHJhdnBsYWNlcy52MS5SZXN0YXJ0RW5naW5lUmVzcG9uc2UiC4rqMAMKARiQ6jACEn0KElRlc3RFeHRlcm5hbFNlYXJjaBIoLnRyYXZwbGFjZXMudjEuVGVzdEV4dGVybmFsU2VhcmNoUmVxdWVzdBopLnRyYXZwbGFjZXMudjEuVGVzdEV4dGVybmFsU2VhcmNoUmVzcG9uc2UiEorqMAMKARSK6jADCgEgkOowAUKtAQoRY29tLnRyYXZwbGFjZXMudjFCEkFkbWluU2V0dGluZ3NQcm90b1ABWi90cmF2cGxhY2VzL2dlbi9wcm90by90cmF2cGxhY2VzL3YxO3RyYXZwbGFjZXN2MaICA1RYWKoCDVRyYXZwbGFjZXMuVjHKAg1UcmF2cGxhY2VzXFYx4gIZVHJhdnBsYWNlc1xWMVxHUEJNZXRhZGF0YeoCDlRyYXZwbGFjZXM6OlYxYgZwcm90bzM", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * @generated from message travplaces.v1.SetSettingRequest
 */
export type SetSettingRequest = Message<"travplaces.v1.SetSettingRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * raw jsonb value, JSON-encoded (e.g. "45", "true", "\"x\"")
   *
   * @generated from field: string value_json = 2;
   */
  valueJson: string;
};

/**
 * Describes the message travplaces.v1.SetSettingRequest.
 * Use `create(SetSettingRequestSchema)` to create a new message.
 */
export const SetSettingRequestSchema: GenMessage<SetSettingRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_settings, 0);

/**
 * @generated from message travplaces.v1.SetSettingResponse
 */
export type SetSettingResponse = Message<"travplaces.v1.SetSettingResponse"> & {
};

/**
 * Describes the message travplaces.v1.SetSettingResponse.
 * Use `create(SetSettingResponseSchema)` to create a new message.
 */
export const SetSettingResponseSchema: GenMessage<SetSettingResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_settings, 1);

/**
 * @generated from message travplaces.v1.RestartEngineRequest
 */
export type RestartEngineRequest = Message<"travplaces.v1.RestartEngineRequest"> & {
  /**
   * @generated from field: string service = 1;
   */
  service: string;
};

/**
 * Describes the message travplaces.v1.RestartEngineRequest.
 * Use `create(RestartEngineRequestSchema)` to create a new message.
 */
export const RestartEngineRequestSchema: GenMessage<RestartEngineRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_settings, 2);

/**
 * @generated from message travplaces.v1.RestartEngineResponse
 */
export type RestartEngineResponse = Message<"travplaces.v1.RestartEngineResponse"> & {
  /**
   * echoes the requested service; no process is acted on
   *
   * @generated from field: string restarted = 1;
   */
  restarted: string;
};

/**
 * Describes the message travplaces.v1.RestartEngineResponse.
 * Use `create(RestartEngineResponseSchema)` to create a new message.
 */
export const RestartEngineResponseSchema: GenMessage<RestartEngineResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_settings, 3);

/**
 * @generated from message travplaces.v1.TestExternalSearchRequest
 */
export type TestExternalSearchRequest = Message<"travplaces.v1.TestExternalSearchRequest"> & {
};

/**
 * Describes the message travplaces.v1.TestExternalSearchRequest.
 * Use `create(TestExternalSearchRequestSchema)` to create a new message.
 */
export const TestExternalSearchRequestSchema: GenMessage<TestExternalSearchRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_settings, 4);

/**
 * @generated from message travplaces.v1.TestExternalSearchResponse
 */
export type TestExternalSearchResponse = Message<"travplaces.v1.TestExternalSearchResponse"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * Names of what the probe actually got back. The admin panel reports
   * "Working — returned N results", so a probe that reaches the provider and
   * finds nothing is distinguishable from one that never got there.
   *
   * @generated from field: repeated string results = 3;
   */
  results: string[];
};

/**
 * Describes the message travplaces.v1.TestExternalSearchResponse.
 * Use `create(TestExternalSearchResponseSchema)` to create a new message.
 */
export const TestExternalSearchResponseSchema: GenMessage<TestExternalSearchResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_settings, 5);

/**
 * AdminSettingsService covers admin-only settings writes and engine ops.
 *
 * SetSetting upserts a single global setting. RestartEngine and
 * TestExternalSearch mirror the legacy admin console: this deployment has no
 * external process/docker control and no configured external search provider,
 * so both are inert stubs that report their non-action rather than performing
 * it.
 *
 * @generated from service travplaces.v1.AdminSettingsService
 */
export const AdminSettingsService: GenService<{
  /**
   * SetSetting upserts one global key/value setting (value is raw JSON).
   *
   * @generated from rpc travplaces.v1.AdminSettingsService.SetSetting
   */
  setSetting: {
    methodKind: "unary";
    input: typeof SetSettingRequestSchema;
    output: typeof SetSettingResponseSchema;
  },
  /**
   * RestartEngine is a no-op stub; it echoes the requested service back.
   *
   * @generated from rpc travplaces.v1.AdminSettingsService.RestartEngine
   */
  restartEngine: {
    methodKind: "unary";
    input: typeof RestartEngineRequestSchema;
    output: typeof RestartEngineResponseSchema;
  },
  /**
   * TestExternalSearch reports external-search availability (always false here).
   *
   * @generated from rpc travplaces.v1.AdminSettingsService.TestExternalSearch
   */
  testExternalSearch: {
    methodKind: "unary";
    input: typeof TestExternalSearchRequestSchema;
    output: typeof TestExternalSearchResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_admin_settings, 0);

